import AddInConfig from "./AddInConfig";

export default AddInConfig;
